/**
 * Plaintext text field that adjusts height to fit user input text inside
 * Inspired by https://stackoverflow.com/a/25621277/8749164
 * Adapted from the Textarea component used in cal-frontend
 */
import React from "react";

export default class Textarea extends React.Component {
  componentDidMount() {
    const el = this.textarea;

    el.style.height = `${el.scrollHeight}px`;
    el.style.overflowY = "hidden";
    el.addEventListener("input", this.updateTextAreaHeight, false);

    this.updateTextAreaHeight();
  }

  componentWillUnmount() {
    // this.textarea.removeEventListener('input');
  }

  updateTextAreaHeight = () => {
    this.textarea.style.height = "auto";
    this.textarea.style.height = `${this.textarea.scrollHeight}px`;
  };

  handleChange = (e) => {
    this.props.onUpdate(e.target.value.replaceAll("\n", "<br>"));
  };

  render() {
    const { name, value, id, className } = this.props;

    return (
      <textarea
        id={id}
        className={className}
        ref={(c) => {
          this.textarea = c;
        }}
        value={value.replaceAll("<br>", "\n")}
        onChange={this.handleChange}
        style={style}
        spellCheck="false"
      />
    );
  }
}

const style = {
  outline: "none",
  resize: "none",
};
